import React from "react";
export class BusyIndicatorDialog extends React.Component<any, any>{
    handleClose = () => {
        this.props.onClose();
    }

    render() {
        var title = this.props.title || "...";
        return <div className="modal fade show in">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" onClick={this.handleClose}><span className="sr-only">Close</span></button>
                        <div style={{ display: "inline" }}>
                            <img style={{ display: "inline" }} src="/Content/kendo/Uniform/loading-image.gif" />
                            <h4 style={{ display: "inline" }} className="modal-title">{title}</h4>
                        </div>
                    </div>
                    <div className="modal-body">
                        {this.props.children}
                    </div>
                </div>
            </div>
        </div>;
    }
};